<template >
    <div class="page">
        <div class="top-title td-fcc">
            <span>常见问题</span>
        </div>
        <div class="ul">
            <div class="li" v-for="(item, index) in dataSources" :key="index">
                <div class="title td-fsc" @click="onPressChange" :data-index="index">
                    <div class="td-f1 title">{{item.title}}</div>
                    <img class="icon" :src="item.active ? Images.icon_arrow_up_blue : Images.icon_arrow_down_black" />
                </div>
                <div class="content" v-if="!!item.active">{{item.content}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    /** 数据区 */
    data() {
        return {
            dataSources: [],
            page: 0,
            limit: 10,
        };
    },
    mounted() {
        this.requestData();
    },
    methods: {
        // 切换显示
        onPressChange (e) {
            let {index} = e.currentTarget.dataset;
            this.dataSources[index].active = !this.dataSources[index].active;
            console.log('this.dataSources---->', this.dataSources);
        },
        async requestData() {
            let url = this.API.faq_list;
            let data = {
                page: this.page,
                limit: this.limit
            };
            let result = await this.$post(url, data);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                let list = result.data || [];
                list.forEach(item => {
                    item.active = 0;
                });
                if (this.page === 1) {
                    this.dataSources = list
                } else {
                    this.dataSources = this.dataSources.concat(list)
                }
                // this.$refs.infinite.finishInfinite(list.length < this.limit);
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        refresh() {
            this.page = 1;
            this.requestData();
            setTimeout(()=>{
                // this.$refs.infinite.finishPullToRefresh();
            },500)
        },
        infinite() {
            this.page++
            this.requestData();
        },
    },
};
</script>

<style lang="less" scoped>
.page{
    background-color: #fff;
    min-height: 100vh;
}
.top-title{
    height: 100px;
    background-image: url('../../assets/img/img_question_banner.png');
    background-size: 100% 100%;
    position: relative;
    padding-bottom: 20px;
    span{
        font-size: 24px;
        text-align: center;
        color: #ffffff;
        font-weight: 500;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, .6);
        letter-spacing: 2px;
    }
}
.ul{
    padding: 15px;
    .li{
        padding: 15px 10px;
        background-color: #f8f8f8;
        border-radius: 5px;
        margin-bottom: 10px;
        .title{
            margin-right: 10px;
            font-size: 14px;
            color: #333;
            font-weight: 500;
        }
        .icon{
            width: 10px;
            height: 10px;
            display: block;
            margin-left: 10px;
        }
        .content {
            font-size: 12px;
            color: #666;
            margin-top: 10px;
        }
    }
}
</style>